import React from 'react';
import {
  Avatar,
  Box,
  Container,
  Flex,
  Heading,
  IconButton,
  Img,
  Link,
  Text,
} from '@chakra-ui/react';
import { FaLinkedin } from 'react-icons/fa';

const TheContextPraxisBlog: React.FC = () => (
  <>
    <Flex
      flexDirection="column"
      overflow="hidden"
      justify="center"
      height="100%"
      py={{ xs: '30px', sm: '40px', md: '60px', lg: '80px' }}
      h="100%"
      minH={{ xs: '400px', lg: '400px' }}
      maxH={{ xs: '400px', lg: '400px' }}
      pos="relative"
    >
      <Img
        pos="absolute"
        objectFit="cover"
        src="/webp/theContext-bg.webp"
        alt="members-hero"
        height="100%"
        width="100%"
      />
      <Box
        bg="linear-gradient(78.35deg, rgba(13, 96, 81, 0.8) 18.38%, rgba(83, 92, 143, 0.8) 86.05%)"
        pos="absolute"
        height="100%"
        width="100%"
        opacity="0.7"
      />
      <Container
        display="flex"
        as="section"
        maxW="container.xl"
        position="relative"
        zIndex="1"
        flexDir={{ xs: 'column', md: 'row' }}
        columnGap="24px"
        rowGap="30px"
        alignItems={{ xs: 'flex-start', md: 'flex-start' }}
        px={{ xs: '14px', sm: '28px', md: '45px', lg: '60px', xl: 'inherit' }}
      >
        <Flex flexDir="column" rowGap="16px">
          <Heading
            color="white"
            fontSize={{ xs: '36px', sm: '42px', lg: '64px' }}
            fontWeight="800"
            lineHeight={{ xs: '35px', lg: '83px' }}
          >
            #TheContext
          </Heading>
          {/* <Heading
            color="white"
            fontSize={{ xs: '28px', sm: '34px' }}
            fontWeight="500"
            lineHeight="32px"
          >
            - By IVCA
          </Heading> */}
        </Flex>
        <Box
          w="1.5px"
          h={{ md: '200px', lg: '300px', xl: '230px' }}
          bgColor="white"
          display={{ xs: 'none', md: 'block' }}
        />
        <Box
          w={{ xs: '70%', sm: '60%' }}
          h="1.5px"
          bgColor="white"
          display={{ xs: 'block', md: 'none' }}
        />
        <Flex flexDir="column" rowGap="8px">
          <Heading
            as="h1"
            mb={{ xs: '10px', md: '20px' }}
            variant="reportCardTitle"
            fontSize={{ xs: '27px', sm: '29px', md: '32px', lg: '54px' }}
            color="white"
            lineHeight={{ xs: '36px', sm: '40px', md: '46px', lg: '70.2px' }}
          >
            $60B Deployed, $28B Exited: India’s Private Investment Story of 2024
          </Heading>
          <Text
            fontSize={{ xs: '18px', sm: '18px', md: '20px', lg: '22px' }}
            fontWeight="600"
            color="white"
            lineHeight="28px"
          >
            Madhur Singhal
          </Text>
          <Text
            fontSize={{ xs: '18px', sm: '18px', md: '20px', lg: '22px' }}
            fontWeight="600"
            color="white"
            lineHeight="28px"
          >
            Rajat Tandon
          </Text>
        </Flex>
      </Container>
    </Flex>
    <Container maxW="container.xl" pb="80px" pt="40px">
      <Flex
        flexDir={{ xs: 'column-reverse', md: 'row' }}
        px={{ xs: '8px', md: '0px' }}
      >
        <Flex
          w={{ xs: '100%', md: '27%' }}
          mt={{ xs: '32px', md: '0px' }}
          flexDir="column"
          rowGap="16px"
          mr={{ xs: '0px', md: '40px' }}
          ml={{ xs: '0px', sm: '10px' }}
          mb={{ xs: '16px', md: '8px' }}
        >
          <Heading
            fontSize="22px"
            lineHeight="22px"
            textAlign={{ xs: 'center', sm: 'left' }}
          >
            Follow the Authors
          </Heading>
          <Box
            w="100%"
            h="1.5px"
            bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
            my="8px"
          />
          {[
            {
              name: 'Madhur Singhal',
              position: 'Managing Partner & CEO, Praxis Global Alliance',
              image:
                'https://static.levocdn.com/WGLBUT82/madhursinghal-NczaXHWSnRUG.jpg',
              linkedIn: 'https://www.linkedin.com/in/madhur-singhal-1386733/',
            },
            {
              name: 'Rajat Tandon',
              position: 'President, IVCA',
              image:
                'https://static.levocdn.com/WGLBUT82/WhatsAppImage2025-02-01at52146PM-tryCJ0OIkI7X.jpeg',
              linkedIn: 'https://www.linkedin.com/in/rajat-tandon-india/',
            },
          ].map((item, index) => (
            // eslint-disable-next-line react/jsx-no-useless-fragment
            <>
              <Flex
                key={index}
                flexDir={{ xs: 'column', sm: 'row', md: 'column' }}
                columnGap="20px"
                rowGap="16px"
              >
                <Flex
                  flexDir="column"
                  alignItems={{ xs: 'center', sm: 'flex-start' }}
                  rowGap="8px"
                >
                  <Box boxSize="95px" borderRadius="50%" overflow="hidden">
                    <Avatar
                      name={item.name}
                      w="100%"
                      h="100%"
                      src={item.image}
                      objectFit="cover"
                    />
                  </Box>
                  <Flex flexDir="column" rowGap="4px">
                    <Flex
                      alignItems="center"
                      gap="12px"
                      justifyContent={{ xs: 'center', md: 'start' }}
                    >
                      <Heading
                        variant="blogQuestion"
                        textAlign={{ xs: 'center', sm: 'left' }}
                      >
                        {item.name}
                      </Heading>
                      <Link href={item?.linkedIn} target="_blank">
                        <IconButton
                          aria-label="linkedin"
                          icon={<FaLinkedin size="28px" color="#067acc" />}
                          variant="unstyled"
                          cursor="pointer"
                        />
                      </Link>
                    </Flex>
                    <Text
                      variant="blogAnswer"
                      textAlign={{ xs: 'center', sm: 'left' }}
                      fontStyle="italic"
                    >
                      {item.position}
                    </Text>
                  </Flex>
                </Flex>
              </Flex>
            </>
          ))}
        </Flex>
        <Flex flexDirection="column" w="100%">
          <Box>
            <Text variant="blogAnswer" mb="20px">
              India continues to witness rapid growth in its private investments
              ecosystem, driven by domestic and international venture and
              private investment funds. Despite global challenges, 2024 has
              proven pivotal, with approximately US$ 11B raised by private
              investment funds and US$ 60B invested across 1,595 deals.
            </Text>
          </Box>
          <Box my="10px">
            <Text variant="blogAnswer" fontWeight="800">
              Fundraising and Investment Trends
            </Text>

            <Text variant="blogAnswer" mt="16px">
              In 2024, private investment funds raised US$ 11B, contributing to
              a total of US$ 60B invested across 1,595 deals. Growth investments
              declined from US$ 15B in 2023 to US$ 10B in 2024, despite an
              increase in the number of growth deals from 234 to 388, driven by
              smaller deal sizes. Additionally, India-focused growth funds
              raised US$ 3.2B, boosting dry powder for future investments.
            </Text>
          </Box>
          <Box my="10px">
            <Text variant="blogAnswer" fontWeight="800">
              Exits Landscape and Investor Sentiment
            </Text>

            <Text variant="blogAnswer" mt="16px">
              India’s exit landscape remained robust, with US$ 28B generated
              from 263 exits in 2024. Growth-stage exits reached US$ 4B, up from
              US$ 3B in 2023, with approximately 60% occurring via public market
              listings. Investors expect this momentum to continue, supported by
              increasing acceptance of Indian companies on public markets.
            </Text>
          </Box>
          <Box my="10px">
            <Text variant="blogAnswer" fontWeight="800">
              India’s Investment Opportunity and Outlook
            </Text>

            <Text variant="blogAnswer" mt="16px">
              India’s growth-stage investment gap, estimated at approximately
              US$ 600B, highlights the country's appeal for domestic and
              international investors. Strong macroeconomic performance further
              boosts investor confidence. Looking ahead to 2025, investors are
              optimistic about sectors including consumer apps and platforms,
              SaaS/AI solutions, e-commerce and listing platforms, and BFSI
              (Banking, Financial Services, and Insurance).
            </Text>
          </Box>
          <Box my="10px">
            <Text variant="blogAnswer" fontWeight="800">
              Insights for Industry Stakeholders
            </Text>

            <Text variant="blogAnswer" mt="16px">
              This report, backed by insights from over 50 leading investors and
              1Lattice™ DealPulse data, offers a comprehensive view of India’s
              private investment landscape. It provides sectoral trends, deal
              size analysis, and investor preferences, serving as a valuable
              resource for private investment funds, business leaders,
              entrepreneurs, government institutions, and policymakers.
            </Text>
          </Box>
          <Box my="10px">
            <Text variant="blogAnswer" fontWeight="800">
              Conclusion
            </Text>

            <Text variant="blogAnswer" mt="16px">
              India’s private investment ecosystem is evolving, driven by a
              strong exit environment, ample dry powder, and promising sectoral
              opportunities. With 2025 on the horizon, sectors such as SaaS/AI,
              consumer platforms, and BFSI are expected to lead the next wave of
              investments. To access the India Growth Equity Report by
              IVCA-Praxis Global Alliance,
            </Text>
          </Box>
        </Flex>
      </Flex>

      <Box w="100%" h="1.5px" mt="16px" mb="8px" bgColor="gray.700" />
      <Text variant="blogAnswer" fontStyle="italic" p="12px 12px 0px">
        <Heading variant="blogQuestion" fontStyle="normal" as="span">
          #TheContext by IVCA{' '}
        </Heading>
        – features opinion makers from the alternate investing industry with
        strong focus on India as investment destination. Watch this space for
        viewpoints on investment themes, emerging trends, economic analysis and
        latest industry insights.
      </Text>
      <Heading
        variant="blogQuestion"
        lineHeight="30px"
        pt="16px"
        fontStyle="italic"
        p="12px 12px 0px"
      >
        Content in this section is curated by team IVCA. To share feedback,
        connect with &nbsp;
        <Link
          href="mailto:paromita.sinha@ivca.in"
          target="_blank"
          style={{ color: 'blue', textDecoration: 'underline' }}
        >
          paromita.sinha@ivca.in
        </Link>
      </Heading>
    </Container>
  </>
);

export default TheContextPraxisBlog;
